import { useEffect, useState } from "react";
import { db } from "../firebase";
import { store } from "../redux/store";
import { collection, query, where, onSnapshot } from "firebase/firestore";
import { firebaseRaceToRace } from "mappers/raceMapper";

export const useRaces = () => {
  const [races, setRaces] = useState([]);
  const user = store.getState().user;

  useEffect(() => {
    const uid = user?.uid;

    if (!uid) {
      setRaces([]);
      return;
    }

    const racesCollection = collection(db, "races");
    const q = query(racesCollection, where("uid", "==", uid));

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const fetchedRaces = snapshot.docs.map((doc) =>
        firebaseRaceToRace({
          id: doc.id,
          ...doc.data(),
        })
      );

      const racesSort = fetchedRaces.sort(function (a, b) {
        return (
          new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        );
      });

      setRaces(racesSort);
    });

    return () => unsubscribe();
  }, [user?.uid]);

  return { races };
};
